import { GroupAffiliateOptions } from "../../types/GeneralTypes";

type ResultObject = {
    selectedObject: null | GroupAffiliateOptions,
    parentObjectValue: string
}
export const FindNestedArrayValue = (dropdownArray: GroupAffiliateOptions[], selectedValue: string = '') => {
    let resultObject: ResultObject = {
        selectedObject: null,
        parentObjectValue: ''
    }
    for (let optionObj of dropdownArray) {
        if (optionObj.value === selectedValue) {
            resultObject.selectedObject = optionObj;
            return resultObject;
        }
        if (optionObj.subAffiliate && optionObj.subAffiliate?.length > 0) {
            const result = FindNestedArrayValue(optionObj.subAffiliate, selectedValue);
            if (result.selectedObject !== null) {
                resultObject.selectedObject = result.selectedObject;
                resultObject.parentObjectValue = optionObj.value;
                return resultObject;
            }
        }
    }
    return resultObject;
};